import { API } from "../../apiSlice";

export const depositMoneyWithMobileMoneyApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    depositMoneyWithMobileMoney: builder.mutation({
      query: (data) => {
        return {
          url: "users/pay",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useDepositMoneyWithMobileMoneyMutation } =
  depositMoneyWithMobileMoneyApiSlice;
